// @angular/core
import { NgModule } from '@angular/core';

// @angular/cdk/overlay
import { ScrollDispatcher } from '@angular/cdk/overlay';

// Directives
import { FangViewportAutoResizeDirective } from './extensions/fang-viewport-auto-resize.directive';

const EXPORTED_DECLARATIONS = [
	FangViewportAutoResizeDirective
];

@NgModule({
	declarations: EXPORTED_DECLARATIONS,
    imports: [],
    exports: EXPORTED_DECLARATIONS,
    providers: [ScrollDispatcher]
})
export class FangVirtualScrollingModule {
}
